import { useState } from 'react';
import {
    Box,
    CircularProgress,
    Dialog,
    IconButton,
    Typography,
    Container
} from '@mui/material';
import ZoomInIcon from '@mui/icons-material/ZoomIn';
import CloseIcon from '@mui/icons-material/Close';

export default function DishImagePreview({ dishImageSrc, dishName, dishPrice, description }) {
    const [imgLoaded, setImgLoaded] = useState(false);
    const [openImageDialog, setOpenImageDialog] = useState(false);

    const displayPrice = (dishPrice ?? 0).toFixed(2).replace('.', ',');

    return (
        <>
            <Container maxWidth={false} disableGutters>

                {dishImageSrc && (
                    <Box
                        sx={{
                            width: '100%',
                            height: 180,
                            overflow: 'hidden',
                            position: 'relative',
                            mb: 2,
                            mt: 5,
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            cursor: 'pointer',
                        }}
                        onClick={() => setOpenImageDialog(true)}
                    >
                        {/* Indicazione "Visualizza immagine" */}
                        <Box
                            sx={{
                                position: 'absolute',
                                top: 34,
                                left: '50%',
                                transform: 'translateX(-50%)',
                                px: 2,
                                py: 0.5,
                                bgcolor: 'rgba(0,0,0,0.7)',
                                color: 'white',
                                borderRadius: 2,
                                display: 'flex',
                                alignItems: 'center',
                                gap: 0.5,
                                fontSize: '0.75rem',
                                fontWeight: 'bold',
                                zIndex: 2,
                                whiteSpace: 'nowrap',
                            }}
                        >
                            <ZoomInIcon sx={{ fontSize: 18 }} />
                            Visualizza Immagine
                        </Box>

                        {/* Spinner */}
                        {!imgLoaded && (
                            <CircularProgress
                                size={36}
                                sx={{ color: 'success.main', position: 'absolute' }}
                            />
                        )}

                        {/* Immagine */}
                        <img
                            src={dishImageSrc}
                            alt={dishName}
                            style={{
                                width: '100%',
                                height: '100%',
                                objectFit: 'contain', 
                                display: imgLoaded ? 'block' : 'none',
                                transition: 'transform 0.4s ease',
                            }}
                            onLoad={() => setImgLoaded(true)}
                        />
                    </Box>
                )}

                <Box sx={{ mx: 2.5, display: 'flex', flexDirection: 'column',  }}>
                    {/* Nome */}
                    <Typography
                        variant="h6"
                        sx={{
                            fontWeight: 'bold',
                            mb: 0.5,
                            color: 'text.primary',
                            textTransform: 'capitalize',
                            wordBreak: 'break-word',
                        }}
                    >
                        {dishName}
                    </Typography>

                    {/* Prezzo */}
                    <Typography
                        variant="subtitle1"
                        sx={{
                            fontWeight: 'bold',
                            mb: 1,
                            color: 'success.main',
                        }}
                    >
                        {displayPrice} €
                    </Typography>

                    {/* Descrizione */}
                    {description && (
                        <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                            {description}
                        </Typography>
                    )}
                </Box>
            </Container>

            {/* Dialog immagine */}
            <Dialog
                open={openImageDialog}
                onClose={() => setOpenImageDialog(false)}
                fullWidth
                maxWidth="sm"
                PaperProps={{
                    sx: {
                        borderRadius: 2,
                        backgroundColor: 'black',
                    },
                }}
            >
                <Box
                    sx={{
                        position: 'relative',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        height: '70vh',
                    }}
                >
                    <IconButton
                        sx={{
                            position: 'absolute',
                            top: 8,
                            right: 8,
                            borderRadius: '50%',
                            p: 0.5,
                            zIndex: 10,
                        }}
                        onClick={() => setOpenImageDialog(false)}
                    >
                        <CloseIcon />
                    </IconButton>

                    <img
                        src={dishImageSrc}
                        alt={dishName}
                        style={{
                            maxHeight: '100%',
                            maxWidth: '100%',
                            borderRadius: '8px',
                            objectFit: 'contain',
                            boxShadow: '0 4px 16px rgba(0,0,0,0.6)',
                        }}
                    />
                </Box>
            </Dialog>
        </>
    );
}
